"use client";

import Image from "next/image";
import {
  DynamicHighlights,
  type DynamicHighlightsProps,
} from "../../sections/DynamicHighlights/DynamicHighlights";

/**
 * Wrapper SSR do bloco 45 — injeta `next/image` via render function (a seção é
 * framework-agnostic e não pode importar `next/*`).
 */
export default (compProps: DynamicHighlightsProps) => {
  const renderImage: DynamicHighlightsProps["renderImage"] = (props) => (
    <Image
      {...props}
      alt={props.alt}
      width={props.width || 800}
      height={props.height || 800}
      sizes="(max-width: 767px) 100vw, 33vw"
      loading={compProps.preload ? "eager" : "lazy"}
      priority={!!compProps.preload}
    />
  );

  return <DynamicHighlights {...compProps} renderImage={renderImage} />;
};
